import { FEDOPS_APP_NAME } from '../constants/fedops';
import { createFedopsLogger } from '../../app/services/create-fedops-logger';

let loadedLogged = false;

export const logger = createFedopsLogger(FEDOPS_APP_NAME);
export const appLoaded = () => {
  if (!loadedLogged) {
    window.Wix.Performance.applicationLoaded();
    logger.appLoaded();
    loadedLogged = true;
  }
};
